import {
    Listbox,
    ListboxButton,
    ListboxOptions,
    ListboxOption,
    Label,
} from '@headlessui/react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleDown } from '@fortawesome/free-solid-svg-icons'
import React from 'react'

export interface Item {
    id: string
    content: React.ReactNode // 👈 can now be any HTML/React element
    disabled?: boolean
}

type Props = {
    id: string
    name: string
    placeholder: string
    items: Item[]
    selected: Item
    onChange: (item: Item) => void
    error?: string
}

export default function Dropdown({
    id,
    name,
    placeholder,
    items,
    selected,
    onChange,
    error,
}: Props): React.JSX.Element {
    return (
        <div className="mb-4">
            <Listbox
                value={selected}
                onChange={onChange}
                as="div"
                className="relative w-full"
            >
                <Label
                    className="block text-sm font-bold mb-1 text-[#333]"
                    as="label"
                >
                    {name}
                </Label>

                <ListboxButton
                    id={id}
                    className={`form-input flex justify-between items-center cursor-pointer ${
                        error ? 'border-red-500' : ''
                    }`}
                >
                    {({ value }) => (
                        <>
                            <div className="flex items-center gap-2">
                                {value?.content || (
                                    <span className="text-gray-400">
                                        {placeholder}
                                    </span>
                                )}
                            </div>
                            <FontAwesomeIcon
                                icon={faAngleDown}
                                className="ml-2 text-gray-500"
                            />
                        </>
                    )}
                </ListboxButton>

                <ListboxOptions className="absolute mt-1 w-full bg-white border border-gray-300 rounded-md shadow-lg z-50 max-h-60 overflow-auto focus:outline-none">
                    {items.map((item) => (
                        <ListboxOption
                            key={item.id}
                            value={item}
                            disabled={item.disabled}
                            className={({ active, selected, disabled }) =>
                                `cursor-pointer px-3 py-2 text-sm flex items-center gap-2 ${
                                    active ? 'bg-blue-100' : ''
                                } ${selected ? 'font-semibold' : ''} ${
                                    disabled
                                        ? 'opacity-50 cursor-not-allowed'
                                        : ''
                                }`
                            }
                        >
                            {item.content}
                        </ListboxOption>
                    ))}
                </ListboxOptions>
            </Listbox>

            {error && <p className="text-red-500 text-sm">{error}</p>}
        </div>
    )
}
